<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <v-btn class="mr-2" fab x-small color="primary" to="/plans">
                <v-icon dark> mdi-arrow-left </v-icon>
              </v-btn>
              <h3
                class="font-weight-bold"
                v-text="
                  isDeletePage() != true
                    ? `Zone Commission for Plan: ${plan.no_of_dogs} Dog ${plan.no_of_walks} Walk ${plan.tier}`
                    : 'Deleted Plans'
                "
              ></h3>
              <template v-if="isDeletePage() != true">
                <v-btn v-can:add="'plans'"
                  class="mx-2 mb-2"
                  fab
                  :loading="isMasterLoading"
                  :disabled="isMasterLoading"
                  x-small
                  color="primary"
                  :to="`/plans/${this.encryptIt(
                    this.plan.id
                  )}/zone-commissions/create`"
                >
                  <v-icon dark> mdi-plus </v-icon>
                </v-btn>
              </template>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search ... "
                    color="#e60040"
                    hide-details="auto"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  >
                  </v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    hide-details="auto"
                    rounded
                    @click:clear="(filter.is_active = null), (page = 1)"
                    v-model="filter.is_active"
                    :items="statuses"
                    label="Status"
                    @input="(page = 1), getData()"
                    placeholder="Filter by Active Status"
                    prepend-inner-icon="mdi-toggle-switch"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col sm="4">
                  <v-autocomplete
                    ref="zone"
                    solo
                    hide-details="auto"
                    rounded
                    @click:clear="(filter.zone_id = null), (page = 1)"
                    v-model="filter.zone_id"
                    :items="zoneItems"
                    label="Zone"
                    @input="(page = 1), getData()"
                    placeholder="Filter by Zone"
                    prepend-inner-icon="mdi-map-marker"
                    clearable
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <section v-if="isLoading" style="height: 575px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                height="575"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left sr_no">Sr No</th>
                      <th class="text-left">Status</th>
                      <th class="text-left">Zone</th>
                      <th class="text-left" style="min-width: 146px">
                        Pet Walker Percent [%] =Commission
                      </th>
                      <th class="text-left" style="min-width: 171px">
                        Franchisee Percent [%] =Commission
                      </th>
                      <th class="text-left" style="min-width: 190px">
                        Master Franchisee Percent [%] =Commission
                      </th>
                      <th class="text-left" style="min-width: 164px">
                        Walkie Percent [%] =Commission
                      </th>
                      <th class="text-left" style="min-width: 160px">
                        Created At
                      </th>
                      <th class="text-right action_th">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="plan_zone_commissions.length != 0">
                    <tr
                      v-for="(zone_commission, i) in plan_zone_commissions"
                      :key="`zone_commission_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': plan_zone_commissions.length - 1 == i,
                      }"
                    >
                      <td style="min-width: 85px">
                        {{ i + 1 }}
                      </td>
                      <td>
                        <v-tooltip bottom v-if="zone_commission.is_active == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span>Plan is Active</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="zone_commission.is_active == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>Plan is InActive</span>
                        </v-tooltip>
                      </td>
                      <td>
                        {{ zone_commission.zone.description}}
                      </td>
                      <td>
                        {{ zone_commission.walkie_percent || "" }}% =
                        {{ zone_commission.walkie_commission_amount || "" }}
                      </td>
                      <td>
                        {{ zone_commission.franchisee_percent || "" }}% =
                        {{ zone_commission.franchisee_commission_amount || "" }}
                      </td>
                      <td>
                        {{ zone_commission.master_franchisee_percent || "" }}% =
                        {{
                          zone_commission.master_franchisee_commission_amount ||
                          ""
                        }}
                      </td>
                      <td>
                        {{ zone_commission.company_percent || "" }}% =
                        {{ zone_commission.company_commission_amount || "" }}
                      </td>
                      <td style="min-width: 160px">
                        {{ formatDate(zone_commission.created_at) }}
                      </td>
                      <td class="text-right" style="min-width: 105px">
                        <template v-if="isDeletePage() != true">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-can:delete="'plans'"
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="OpenWarning(zone_commission.id)"
                              >
                                <v-icon dark> mdi-delete </v-icon>
                              </v-btn>
                            </template>
                            <span>Delete this Zone Commission</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="ml-2"
                                fab
                                x-small
                                color="primary"
                                :to="`/zone-commissions/${encryptIt(
                                  zone_commission.id
                                )}`"
                              >
                                <v-icon dark> mdi-pencil </v-icon>
                              </v-btn>
                            </template>
                            <span>Edit this Plan</span>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-can:delete="'plans'"
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="Restore_this(zone_commission.id)"
                              >
                                <v-icon dark> mdi-delete-restore </v-icon>
                              </v-btn>
                            </template>
                            <span>Restore this zone_commission</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="100" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination rounded v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_deleted_plan" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Zone Commission deleted successfully.</h3>
                      <br />
                      <v-btn color="success" @click="is_deleted_plan = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_restored_plan" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-restore
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Plan restored successfully.</h3>
                      <br />
                      <v-btn color="success" @click="is_restored_plan = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Delete Warning Dialog Box -->
      <v-dialog v-model="deleteDialog" width="550px">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 150px"
                >
                  mdi-delete-alert
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Warning!</h1>
                      <br />
                      <h3>Are you sure you want to delete this?</h3>
                      <br />
                      <v-btn color="grey" dark @click="deleteDialog = false"
                        >Cancel</v-btn
                      >
                      <v-btn
                        color="red"
                        dark
                        class="ml-5"
                        @click="
                          Delete_this(to_be_deleted_id), (deleteDialog = false)
                        "
                        >Delete</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "PlanZoneCommissionsPage",
  data() {
    return {
      filter: {
        search_keyword: "",
        is_active: "",
        show_deleted: false,
      },
      plan: {
        no_of_dogs:"",
        no_of_walks:"",
        tier:"",
      },
      statuses: [
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      ExportPlanTypes: [],
      plan_zone_commissions: [],
      zoneItems: [],
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      excel_fields: {
        "Sr No": "sr_no",
        Name: "name",
      },
      isLoading: false,
      isMasterLoading: false,
      isExcelloading: false,
      delete_plan: false,
      is_deleted_plan: false,
      restore_plan: false,
      is_restored_plan: false,
      deleteDialog: false,
      to_be_deleted_id: "",
    };
  },
  watch: {
    page: "getData",
    $route() {
      this.getMasters();
      this.getPlanData();
    },
  },
  mounted() {
    this.getMasters();
    this.getPlanData();
  },
  methods: {
    formatDate(value) {
      if (!value) return "";
      try {
        const d = new Date(value);
        const pad = (n) => String(n).padStart(2, "0");
        const day = pad(d.getDate());
        const month = pad(d.getMonth() + 1);
        const year = d.getFullYear();
        const hours = pad(d.getHours());
        const minutes = pad(d.getMinutes());
        const seconds = pad(d.getSeconds());
        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
      } catch (e) {
        return value;
      }
    },
    OpenWarning(request_id) {
      this.to_be_deleted_id = request_id;
      this.deleteDialog = true;
    },
    async getMasters() {
      this.isMasterLoading = true;
      await axios
        .get(`masters?context=zone_commissions`)
        .then((masters) => {
          masters = masters.data;
          //Position
          masters.zones.forEach((zone) => {
            this.zoneItems.push({
              id: zone.id,
              text: zone.description,
              value: zone.id,
            });
          });
        })
        .catch((error) => {
          console.error(error);
          this.isUnAuthorised();
        });
      this.isMasterLoading = false;
    },
    async getPlanData() {
      this.isLoading = true;
      let encryptedId = this.$route.params.planId;
      axios
        .get(`/plans/${encryptedId}`)
        .then((response) => {
          this.plan = response.data.data;
          this.getData();
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
      this.isLoading = false;
    },
    async getData() {
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.zone_id = this.filter.zone_id ? this.filter.zone_id : "";
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&show_deleted=" +
        this.filter.show_deleted +
        "&plan_id=" +
        this.plan.id +
        "&zone_id=" +
        this.filter.zone_id +
        "&tier=" +
        this.filter.tier +
        "&is_active=" +
        this.filter.is_active +
        "&search_keyword=" +
        this.filter.search_keyword;
      await axios
        .get(`plan_zone_commissions?${query}`)
        .then((response) => {
          this.plan_zone_commissions = response.data.data;
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch((error) => {
          console.error(error);
          this.isUnAuthorised();
        });
      this.isLoading = false;
    },
    //Generate Excel
    async generateExcel() {
      let query = "search_keyword=" + this.filter.search_keyword;
      let response = await axios.get(`plan_exports?${query}`);
      console.log(response.data.data);
      if (response) {
        window.open(`${response.data.data}`, "_blank");
      }
    },
    async Delete_this(id) {
      this.delete_plan = true;
      await axios
        .post(`/plan_zone_commissions/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.delete_plan = false;
          this.is_deleted_plan = true;
          this.getData();
        })
        .catch((error) => {
          console.error(error);
          this.isUnAuthorised();
        });
    },
    async Restore_this(id) {
      this.restore_plan = true;
      await axios
        .post(`/plan_zone_commissions/restore/${this.encryptIt(id)}`)
        .then(() => {
          this.restore_plan = false;
          this.is_restored_plan = true;
          this.getData();
        })
        .catch((error) => {
          console.error(error);
          this.isUnAuthorised();
        });
    },
  },
};
</script>
